import {Controller, useForm, useWatch} from 'react-hook-form';
import {Button, SelectRadioButton} from 'components/ui';
import Select, {SingleValue} from 'react-select';
import {CompositionCompetence} from 'APIs/letrusAPI/compositionCompetence/types';
import {SelectedOptions} from 'containers/EvolutionDashboard';
import styles from './SelectedFilter.module.scss';

interface SelectedFilterProps {
  fetchOptionsCompetences: (id: number | string) => void;
  compositionCompetence: CompositionCompetence[];
  isCompetenceLoading: boolean;
  updateAnnualReportByFilter: (options: SelectedOptions) => void;
  selectedOptions: SelectedOptions;
}

const gradeOptions = [
  {label: 'ENEM', value: 'ENEM'},
  {label: 'Multigênero', value: 'Multigênero'},
];

const viewOptions = [
  {label: 'Nota Total', value: 'total'},
  {label: 'Por Competência', value: 'competence'},
];

function SelectedFilter({
  fetchOptionsCompetences,
  compositionCompetence,
  isCompetenceLoading,
  updateAnnualReportByFilter,
  selectedOptions,
}: SelectedFilterProps) {
  const {control, handleSubmit, setValue} = useForm<SelectedOptions>({
    defaultValues: selectedOptions,
  });

  const selectedView = useWatch({control, name: 'view'});
  const selectedGrade = useWatch({control, name: 'grade'});

  const onSubmit = (data: SelectedOptions) => {
    updateAnnualReportByFilter(data);
  };

  const competenceOptions = compositionCompetence?.map((competence) => ({
    label: competence?.name,
    value: competence?.id,
  }));

  return (
    <form className={styles.container} onSubmit={handleSubmit(onSubmit)}>
      <article className={styles.optionsFilters}>
        <fieldset>
          <label htmlFor="grade">Grade Curricular *</label>

          <Controller
            name="grade"
            control={control}
            render={({field}) => (
              <Select
                {...field}
                options={gradeOptions}
                placeholder="Selecione uma grade"
                isClearable={false}
                value={gradeOptions?.find(
                  (option) => option?.value === field?.value,
                )}
                onChange={(
                  option: SingleValue<{label: string; value: string}>,
                ) => {
                  const newGrade = option?.value;
                  field?.onChange(newGrade);
                  setValue('view', 'total');
                }}
              />
            )}
          />
        </fieldset>

        <fieldset>
          <label>Tipo de Visualização</label>
          <section className={styles.radiosOptions}>
            <Controller
              name="view"
              control={control}
              render={({field}) => (
                <>
                  {viewOptions?.map((option) => (
                    <label key={option?.value}>
                      <SelectRadioButton
                        labelText={option?.label}
                        checked={field?.value === option?.value}
                        onChange={() => {
                          if (option?.value === 'competence') {
                            fetchOptionsCompetences(
                              selectedGrade === 'ENEM' ? 1 : 61,
                            );
                          }
                          field?.onChange(option?.value);
                        }}
                      />
                    </label>
                  ))}
                </>
              )}
            />
          </section>
        </fieldset>

        {selectedView === 'competence' && (
          <fieldset>
            <label htmlFor="competence">Competência</label>

            <Controller
              name="competence"
              control={control}
              render={({field}) => (
                <Select
                  {...field}
                  options={competenceOptions}
                  placeholder="Selecione uma competência"
                  isClearable
                  value={competenceOptions?.find(
                    (option) => option?.value === field?.value,
                  )}
                  onChange={(
                    option: SingleValue<{label: string; value: string}>,
                  ) => field?.onChange(option?.value)}
                  isLoading={isCompetenceLoading}
                />
              )}
            />
          </fieldset>
        )}
      </article>

      <Button type="submit" variant="primary" text="Filtrar" />
    </form>
  );
}

export default SelectedFilter;
